<template>
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-5">
        <div class="card shadow-sm">
          <div class="card-body p-4">
            <h2 class="card-title text-center mb-1">Recuperar contraseña</h2>
            <p class="text-muted text-center mb-4 small">Introduce tu email y te enviaremos un enlace para restablecerla</p>

            <div v-if="enviado" class="alert alert-success">
              <i class="bi bi-envelope-check me-2"></i>
              Si el email está registrado, recibirás un enlace de recuperación en breve.
            </div>

            <div v-if="error" class="alert alert-danger">{{ error }}</div>

            <form v-if="!enviado" @submit.prevent="handleSubmit">
              <div class="mb-3">
                <label class="form-label">Email</label>
                <input
                  type="email"
                  class="form-control"
                  v-model="email"
                  placeholder="tu@email.com"
                  required
                  autofocus
                />
              </div>
              <div class="d-grid mb-3">
                <button type="submit" class="btn btn-primary" :disabled="loading">
                  <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                  {{ loading ? 'Enviando...' : 'Enviar enlace de recuperación' }}
                </button>
              </div>
            </form>

            <div class="text-center">
              <router-link to="/login" class="text-muted small">
                <i class="bi bi-arrow-left me-1"></i> Volver al inicio de sesión
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import axios from '../config/axios';

export default {
  name: 'ForgotPasswordView',
  setup() {
    const email = ref('');
    const loading = ref(false);
    const enviado = ref(false);
    const error = ref('');

    const handleSubmit = async () => {
      loading.value = true;
      error.value = '';
      try {
        await axios.post('/api/auth/forgot-password', { email: email.value });
        enviado.value = true;
      } catch (err) {
        error.value = err.response?.data?.error || 'Error al enviar el email. Inténtalo de nuevo.';
      } finally {
        loading.value = false;
      }
    };

    return { email, loading, enviado, error, handleSubmit };
  }
};
</script>
